"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_1 = require("@prosay/i18n");
const yup = __importStar(require("yup"));
const input_1 = require("./input");
exports.acceptCase = yup.object({
    id: input_1.id.required(),
});
exports.createConversation = yup.object({
    title: input_1.conversationQuestion
        .required()
        .label(i18n_1.translate("validation.labels.conversationQuestion")),
    topicId: input_1.id.required(),
});
exports.editTextMessage = yup.object({
    id: input_1.id.required(),
    textContent: input_1.messageContent
        .required()
        .label(i18n_1.translate("validation.labels.conversationMessageContent")),
});
exports.login = yup.object({
    id: input_1.id.required(),
    token: input_1.refreshToken.required(),
});
exports.logout = yup.object({
    token: input_1.refreshToken.required(),
});
exports.markConversationAsLookingForLawyer = yup.object({
    id: input_1.id.required(),
});
exports.register = yup.object({
    phoneNumber: input_1.phoneNumber
        .required()
        .label(i18n_1.translate("validation.labels.phoneNumber")),
});
exports.registerLawyer = yup.object({
    inviteCode: input_1.inviteCode
        .required()
        .label(i18n_1.translate("validation.labels.inviteCode")),
    phoneNumber: input_1.phoneNumber
        .required()
        .label(i18n_1.translate("validation.labels.phoneNumber")),
});
exports.removeConversation = yup.object({
    id: input_1.id.required(),
});
exports.removeMessage = yup.object({
    id: input_1.id.required(),
});
exports.resolveCase = yup.object({
    id: input_1.id.required(),
});
exports.sendMessage = yup.object({
    conversationId: input_1.id.required(),
    imageContent: input_1.upload,
    textContent: input_1.messageContent.label(i18n_1.translate("validation.labels.conversationMessageContent")),
    voiceContent: input_1.upload,
});
exports.sendNewPhoneNumberToken = yup.object({});
exports.submitNotificationToken = yup.object({
    token: input_1.notificationToken.required(),
});
exports.submitPhoneNumberToken = yup.object({
    token: input_1.phoneNumberToken
        .required()
        .label(i18n_1.translate("validation.labels.phoneNumberVerificationToken")),
});
exports.undoRemoveMessage = yup.object({
    id: input_1.id.required(),
});
exports.unresolveCase = yup.object({
    id: input_1.id.required(),
});
//# sourceMappingURL=data:application/json;base64,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